import { useContext } from 'react';
import { VasTeam, VasTeamData, VasTeamImpl } from '../types';
import { COLLECTIONS } from '../firebase/firestoreUtils';
import { createYearScopedAdminCollection } from './yearScopedAdminCollection';

const { Context, Provider } = createYearScopedAdminCollection<VasTeamData, VasTeam>({
    collection: COLLECTIONS.VAS_TEAMS,
    label: 'Vas teams',
    wrap: data => new VasTeamImpl(data),
    toUpdatePayload: team => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { id, createdAt, updatedAt, memberCount, contactableMembers, memberEmails, ...rest } = team;
        return rest;
    },
});

export const VasTeamsContext = Context;
export const VasTeamsProvider = Provider;

export const useVasTeams = () => {
    const ctx = useContext(VasTeamsContext);
    if (!ctx) throw new Error('useVasTeams must be used within a VasTeamsProvider');
    return {
        teams: ctx.items,
        isLoading: ctx.isLoading,
        addTeam: ctx.add,
        updateTeam: ctx.update,
        deleteTeam: ctx.remove,
    };
};
